import ListingVM from './listing-vm'

export default {
  init(node) {
    const params = $('#articles-json').val()
    ko.applyBindings(new ListingVM(params, node), node)
  }
}

